// @ts-ignore
// @ts-nocheck
import { toast } from 'react-toastify';
import { AxiosError, AxiosRequestConfig } from 'axios';
import { format } from 'date-fns';
import { getAccessToken } from './accessTokenServices';
import api from './api';

type ErrorData = {
  response: {
    data: {
      message: string;
    };
    status: string;
  };
};

type SaveRefuelRequest = {
  installBase: string;
  isFixRoute: boolean;
  detail: string;
  name: string;
  email: string;
  phone: string;
  refuelDate: string;
  currentGasPercentage: string;
};

type SaveRefuelResponse = {
  caseNumber: string | null;
  dataMessage: string;
  isError: boolean;
  createdDate?: string;
};

export const saveRefuelData = async ({
  installBase,
  isFixRoute,
  detail,
  name,
  email,
  phone,
  refuelDate,
  currentGasPercentage,
}: SaveRefuelRequest): Promise<SaveRefuelResponse> => {
  let message = '';
  const access_token = await getAccessToken();
  const contactIdSf = localStorage.getItem('@UltragazEmpresarial:contactIdSf');
  const customerSiteId = localStorage.getItem(
    '@UltragazEmpresarial:customerSiteId'
  );

  const header = {
    'Content-Type': 'application/json',
    access_token,
  };

  const parameters = {
    method: 'POST',
    headers: header,
  } as AxiosRequestConfig;

  const refuelDateArray = refuelDate?.split('/');
  const refuelDateCustom = `${refuelDateArray[2]}-${refuelDateArray[1]}-${refuelDateArray[0]}`;

  const body = {
    customerSiteId,
    installBase,
    subject: isFixRoute
      ? 'GRANEL - Pedido (Com Rota Fixa)'
      : 'GRANEL - Pedido (Sem Rota Fixa)',
    reason: 'EQUIPAMENTOS',
    detail,
    name,
    email,
    phone: phone.replace(/[^0-9]+/g, ''),
    research: 'Realizada',
    refuelDate: refuelDateCustom,
    currentGasPercentage,
    ...(contactIdSf && { contactIdSf }),
  };

  try {
    const responsePost = await api.post(
      'industrial/case/v1/refuels',
      body,
      parameters
    );

    if (responsePost.status === 201) {
      parameters.method = 'GET';

      const responseGet = await api.get(
        `industrial/case/v1/refuels/${responsePost.data?.caseId}`,
        parameters
      );

      return {
        caseNumber: responseGet.data?.caseNumber,
        dataMessage: responsePost.data?.message || '',
        createdDate: responseGet.data?.createdDate || '',
        isError: false,
      };
    }
  } catch (error) {
    const errorResponse = error as AxiosError | ErrorData;
    if (errorResponse?.response) {
      message = errorResponse.response.data.message;
      if (message) {
        toast.error(message);
      } else {
        toast.error('Ocorreu um erro interno na aplicação');
      }
      return {
        caseNumber: null,
        dataMessage: message,
        isError: true,
      };
    }
  }
  return {
    caseNumber: null,
    dataMessage: '',
    isError: false,
    createdDate: '',
  };
};

export const getLatsDate = async (): Promise<any> => {
  let message = '';
  const access_token = await getAccessToken();
  const customerSiteId = localStorage.getItem(
    '@UltragazEmpresarial:customerSiteId'
  );

  const header = {
    'Content-Type': 'application/json',
    access_token,
  };

  const parameters = {
    method: 'get',
    headers: header,
  } as AxiosRequestConfig;

  try {
    const responseGet = await api.get(
      `industrial/case/v1/refuels/last?customer-site-id=${customerSiteId}`,
      parameters
    );

    return responseGet.data;
  } catch (error) {
    const errorResponse = error as AxiosError | ErrorData;
    if (errorResponse?.response) {
      message = errorResponse.response.data.message;
      if (message) {
        toast.error(message);
      } else {
        toast.error('Ocorreu um erro interno na aplicação');
      }
      return {
        dataMessage: message,
      };
    }
  }
  return null;
};

export const getRefuelsData = async (
  activePage = 1,
  itemsPerPage = 10,
  requestParams = '',
  installBasesParam = '',
  startDate: Date | null = null,
  endDate: Date | null = null
): Promise<any> => {
  let message = '';
  const access_token = await getAccessToken();

  const customerId = localStorage.getItem('@UltragazEmpresarial:customerId');

  const customerSiteId = localStorage.getItem(
    '@UltragazEmpresarial:customerSiteId'
  );

  const customerCode = localStorage.getItem(
    '@UltragazEmpresarial:customerCode'
  );
  const customerSiteCode = localStorage.getItem(
    '@UltragazEmpresarial:customerSiteCode'
  );

  const header = {
    'Content-Type': 'application/json',
    access_token,
  };

  const parameters = {
    method: 'get',
    headers: header,
  } as AxiosRequestConfig;

  const newParams = `&customer-code=${customerCode}&customer-site-code=${customerSiteCode}`;
  const startDateParam = startDate
    ? `&begin-date=${format(startDate, 'yyyy-MM-dd')}`
    : '';
  const endDateParam = endDate
    ? `&end-date=${format(endDate, 'yyyy-MM-dd')}`
    : '';

  const url = `/industrial/case/v1/refuels?customer-id=${customerId}&customer-site-id=${customerSiteId}&_limit=${itemsPerPage}&_offset=${
    activePage - 1
  }&_expand=requestedCase${requestParams}${newParams}${installBasesParam}${startDateParam}${endDateParam}`;

  try {
    const responseGet = await api.get(url, parameters);

    return {
      data: responseGet.data,
      pageTotal: responseGet.headers['total-pages'],
    };
  } catch (error) {
    const errorResponse = error as AxiosError | ErrorData;
    if (errorResponse?.response) {
      message = errorResponse.response.data.message;
      if (message) {
        toast.error(message);
      } else {
        toast.error('Ocorreu um erro interno na aplicação');
      }
      return {
        dataMessage: message,
      };
    }
  }
  return null;
};

export const getRefuelsCountData = async (
  activePage = 1,
  itemsPerPage = 10,
  installBasesParam = '',
  startDate: Date | null = null,
  endDate: Date | null = null
): Promise<any> => {
  let message = '';
  const access_token = await getAccessToken();

  const customerId = localStorage.getItem('@UltragazEmpresarial:customerId');

  const customerSiteId = localStorage.getItem(
    '@UltragazEmpresarial:customerSiteId'
  );

  const customerCode = localStorage.getItem(
    '@UltragazEmpresarial:customerCode'
  );
  const customerSiteCode = localStorage.getItem(
    '@UltragazEmpresarial:customerSiteCode'
  );

  const header = {
    'Content-Type': 'application/json',
    access_token,
  };

  const parameters = {
    method: 'get',
    headers: header,
  } as AxiosRequestConfig;

  const newParams = `&customer-code=${customerCode}&customer-site-code=${customerSiteCode}`;
  const startDateParam = startDate
    ? `&begin-date=${format(startDate, 'yyyy-MM-dd')}`
    : '';
  const endDateParam = endDate
    ? `&end-date=${format(endDate, 'yyyy-MM-dd')}`
    : '';

  const url = `/industrial/case/v1/refuels/status-counters?customer-id=${customerId}&customer-site-id=${customerSiteId}&_limit=${itemsPerPage}&_offset=${
    activePage - 1
  }&_expand=requestedCase&_expand=orderStatus${newParams}${installBasesParam}${startDateParam}${endDateParam}`;

  try {
    const responseGet = await api.get(url, parameters);

    return responseGet.data;
  } catch (error) {
    const errorResponse = error as AxiosError | ErrorData;
    if (errorResponse?.response) {
      message = errorResponse.response.data.message;
      if (message) {
        toast.error(message);
      } else {
        toast.error('Ocorreu um erro interno na aplicação');
      }
      return {
        dataMessage: message,
      };
    }
  }
  return null;
};

export const getRefuelsDataByCaseId = async (
  caseId: string | null = null,
  supplyId: string | null = null
): Promise<any> => {
  let message = '';
  const access_token = await getAccessToken();

  const customerId = localStorage.getItem('@UltragazEmpresarial:customerId');

  const customerSiteId = localStorage.getItem(
    '@UltragazEmpresarial:customerSiteId'
  );

  const customerCode = localStorage.getItem(
    '@UltragazEmpresarial:customerCode'
  );
  const customerSiteCode = localStorage.getItem(
    '@UltragazEmpresarial:customerSiteCode'
  );

  const header = {
    'Content-Type': 'application/json',
    access_token,
  };

  const parameters = {
    method: 'get',
    headers: header,
  } as AxiosRequestConfig;

  const newParams = `&customer-code=${customerCode}&customer-site-code=${customerSiteCode}`;

  const url = `/industrial/case/v1/refuels/${
    caseId ?? supplyId
  }/?customer-id=${customerId}&customer-site-id=${customerSiteId}${newParams}`;

  try {
    const responseGet = await api.get(url, parameters);

    return responseGet.data;
  } catch (error) {
    const errorResponse = error as AxiosError | ErrorData;
    if (errorResponse?.response) {
      message = errorResponse.response.data.message;
      if (message) {
        toast.error(message);
      } else {
        toast.error('Ocorreu um erro interno na aplicação');
      }
      return {
        dataMessage: message,
      };
    }
  }
  return null;
};

export const saveRefuelDataV2 = async ({
  installBase,
  isFixRoute,
  detail,
  name,
  email,
  phone,
  refuelDate,
  currentGasPercentage,
}: SaveRefuelRequest): Promise<SaveRefuelResponse> => {
  let message = '';
  const access_token = await getAccessToken();
  const contactIdSf = localStorage.getItem('@UltragazEmpresarial:contactIdSf');
  const customerSiteId = localStorage.getItem(
    '@UltragazEmpresarial:customerSiteId'
  );

  const header = {
    'Content-Type': 'application/json',
    access_token,
  };

  const parameters = {
    method: 'POST',
    headers: header,
  } as AxiosRequestConfig;

  const refuelDateCustom = refuelDate;

  const body = {
    customerSiteId,
    installBase,
    subject: isFixRoute
      ? 'GRANEL - Pedido (Com Rota Fixa)'
      : 'GRANEL - Pedido (Sem Rota Fixa)',
    reason: 'EQUIPAMENTOS',
    detail,
    name,
    email,
    phone: phone.replace(/[^0-9]+/g, ''),
    research: 'Realizada',
    refuelDate: refuelDateCustom,
    currentGasPercentage,
    ...(contactIdSf && { contactIdSf }),
  };

  try {
    const responsePost = await api.post(
      'industrial/case/v1/refuels',
      body,
      parameters
    );

    if (responsePost.status === 201) {
      parameters.method = 'GET';

      const responseGet = await api.get(
        `industrial/case/v1/refuels/${responsePost.data?.caseId}`,
        parameters
      );

      return {
        caseNumber: responseGet.data?.caseNumber,
        dataMessage: responsePost.data?.message || '',
        createdDate: responseGet.data?.createdDate || '',
        isError: false,
      };
    }
  } catch (error) {
    const errorResponse = error as AxiosError | ErrorData;
    if (errorResponse?.response) {
      message = errorResponse.response.data.message;
      if (message) {
        toast.error(message);
      } else {
        toast.error('Ocorreu um erro interno na aplicação');
      }
      return {
        caseNumber: null,
        dataMessage: message,
        isError: true,
      };
    }
  }
  return {
    caseNumber: null,
    dataMessage: '',
    isError: false,
    createdDate: '',
  };
};
